module.exports = {
  UPDATE_CONFIG: 'UPDATE_CONFIG',
};
